import actions from './actions';

const initState = {
    connected: false,
    connecting: false,
};

export default function socketReducer(state = initState, action) {
    switch (action.type) {
        case actions.SOCKET_CONNECTING:
            return { ...state, connecting: true, connected: false };
        case actions.SOCKET_CONNECTED:
            return { ...state, connecting: false, connected: true };
        case actions.SOCKET_DISCONNECTED:
            return { ...state, connecting: false, connected: false };
        default:
            return state;
    }
}
